import RichTextEditorStyles from '@utils/RichTextEditorStyles';
import React from 'react';
import { useMicrosite } from '../../contexts/franchise/microsite-context/index.tsx';
import ServProFlag from '../../images/servproflag.jpg';
import Color, { colors } from '../primitives/colors';
import Col from '../primitives/grid/col';
import Container from '../primitives/grid/container';
import Row from '../primitives/grid/row';
import RichText from '../primitives/richtext';
import { StyledButtonAsLink } from '../primitives/styled-button';
import { breakpoints } from '../primitives/tokens';

const styles = {
    image: {
        objectFit: 'contain',
        width: '100%',
        '@media (min-width: 1025px)': {
            maxWidth: '520px',
        },
    },
    contentWrap: {
        margin: 'auto',
        [breakpoints.tb]: {
            paddingBottom: '48px',
        },
    },
    containerWrap: {
        padding: '100px 0',
        [breakpoints.tb]: {
            padding: '48px 0',
        },
    },
    owners: {
        textAlign: 'center',
        paddingTop: '0.5rem',
        marginTop: '0.5rem',
        fontSize: '1.125rem',
        lineHeight: '1.75rem',
        fontWeight: 700,
        color: colors.shadesBlack,
    },
    ownersSubline: {
        color: colors.shadesBlack,
        textAlign: 'center',
        marginTop: '0.5rem',
    },
    imageWrap: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        '@media (min-width: 1025px)': {
            maxWidth: '520px',
        },
        '@media (min-width: 1280px)': {
            alignSelf: 'end',
        },
    },
    buttonAsLinkWrap: {
        display: 'flex',
        paddingTop: '2rem',
        alignSelf: 'flex-start',
        width: '100%',
        '@media (min-width: 1280px)': {
            width: 'auto',

        },
    },
    mediaContentCopy: {
        marginBottom: '1.5rem',
        'p, li': {
            fontSize: '1.125rem',
            lineHeight: '1.75rem',
            '@media (min-width: 1280px)': {
                fontSize: '1.25rem',
                lineHeight: '1.75rem',
            },
        },
        button: {
            display: 'inline-block',
            overflow: 'hidden',
            position: 'relative',
            paddingRight: '2.5rem',
            marginBottom: '2rem',
            marginTop: '3rem',
            borderColor: '#ffffff',
            whiteSpace: 'nowrap',
            ':before': {
                display: 'block',
                position: 'absolute',
                top: '0',
                bottom: '0',
                right: '1.5rem',
                width: '46px',
                '--transform-rotate': '45deg',
                transform: 'rotate(45deg)',
                content: "''",
                backgroundColor: colors.primaryOrange,
            },
            ':after': {
                display: 'block',
                position: 'absolute',
                top: '0',
                bottom: '0',
                right: '0.75rem',
                borderTopWidth: '4px',
                borderRightWidth: '4px',
                width: '46px',
                '--transform-rotate': '45deg',
                transform: 'rotate(45deg)',
                content: "''",
                borderColor: colors.primaryOrange,
            },
        },
        '@media (min-width: 1280px)': {
            '@media (min-width: 1280px)': {
                fontSize: '1.125rem',
                lineHeight: '1.75rem',
            },
        },
    },
};

const FranchiseGlobalAbout = () => {
    const microsite = useMicrosite();

    if (!microsite.allowedInternalLinks.includes('/about')) {
        return null;
    }

    return (
        <Color
            backgroundColor="grey100"
            css={styles.containerWrap}
        >
            <Container>
                <Row>
                    <Col breakpoints={{ dt: { span: 6 } }}>
                        <div css={styles.contentWrap}>
                            <div css={RichTextEditorStyles}>
                                <h2>About Us</h2>
                            </div>
                            <RichText
                                maxLength={4}
                                css={styles.mediaContentCopy}
                                disabled
                            >
                                {microsite?.franchise?.profileExcerpt}
                            </RichText>
                            <div css={styles.buttonAsLinkWrap}>
                                <StyledButtonAsLink to={`${microsite?.permalink}/about`}>Read More</StyledButtonAsLink>
                            </div>
                        </div>
                    </Col>
                    <Col breakpoints={{ dt: { span: 6 } }}>
                        <div css={styles.imageWrap}>
                            <img
                                css={styles.image}
                                src={microsite?.franchise?.aboutUs?.ownerPicture || ServProFlag}
                                alt={microsite?.franchise?.aboutUs?.ownerPicture ? microsite?.franchise?.aboutUs?.owners : 'SERVPRO flag'}
                            />
                            {microsite?.franchise?.aboutUs?.owners && (
                                <div css={styles.owners}>{microsite?.franchise?.aboutUs?.owners}</div>
                            )}
                            {microsite?.franchise?.aboutUs?.ownerPicture && microsite?.franchise?.name && (
                                <div css={styles.ownersSubline}>
                                    {microsite?.franchise?.aboutUs?.multipleOwners ? 'Owners of' : 'Owner of'}
                                    {' '}
                                    {microsite?.franchise?.name}
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </Color>
    );
};

export default FranchiseGlobalAbout;
